import axios from "axios";
import state from "../store";

let baseURL = state.getters.mainAppURL + "riders/";
const getAllRiderBranches = (rider_id) => axios.post( baseURL + "get_rider_branches" , rider_id);
const removeBranchFromRider = (branch_id) => axios.post(baseURL + "delete_rider_branch" , branch_id);
const addBranchToRider = (params) => axios.post(baseURL + "add_rider_branches" , params);
const addUpdateRider = (params) => axios.post(baseURL , params);
const toggleRider = (riderId) => axios.put(baseURL + "toggle_rider/" + riderId)
const deleteRider = (riderId) => axios.delete(baseURL + riderId);
const deleteRiderBranch = (params) => axios.post(state.getters.mainAppURL + "delete_rider_branch" , params);

export {
    getAllRiderBranches,
    addBranchToRider,
    addUpdateRider,
    removeBranchFromRider,
    toggleRider,
    deleteRiderBranch,
    deleteRider
}